const headers = {
  name: "Project gallery",
  navigate: {
    path: [
      {
        name: "Gallery",
        path: "/app/projects/gallery",
      },
      {
        name: "Add",
        path: "",
      },
    ],
  },
};

export default headers;
